// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-link[data-v-4f7c94c0]{text-decoration:none;color:#1e43a3}.home-link[data-v-4f7c94c0]:hover{text-decoration:underline}.icon[data-v-4f7c94c0]{float:left;width:32px;margin-right:10px;position:relative;top:-5px}.transactions[data-v-4f7c94c0]{margin-bottom:80px}", ""]);
// Exports
module.exports = exports;
